import { observer } from "mobx-react-lite";
import styled from "@emotion/styled";
import { PageBannerSection } from "@/components/banners/page-banner-section";
import { MDSPanelHeader, MDSText, MDSTextVariant, MDSPanelHeaderSlotName } from "@/mds";

export const SessionsListPageHeader = observer(() => {
  return (
    <Wrapper>
      <MDSPanelHeader>
        <MDSText
          slot={MDSPanelHeaderSlotName.Heading}
          variant={MDSTextVariant.HeaderXl}
          numberOfLines={1}
        >
          Sessions
        </MDSText>
      </MDSPanelHeader>
      <PageBannerSection />
    </Wrapper>
  );
});

const Wrapper = styled.div({});
